import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getAllTickets = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/all/tenant/ticktes?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// دالة لتغيير حالة التذكرة إلى مقروءة
export const markTicketAsSeen = (ticketId) => {
  const token = localStorage.getItem("authToken");
  return api.get(`make/it/seen/${ticketId}?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};


// دالة لتغيير حالة تسجيل الدخول إلى مقروءة
export const markTenantLoginAsSeen = (tenantId) => {
  const token = localStorage.getItem("authToken");
  return api.get(
    `mark/login/seen/${tenantId}?api_password=${API_PASSWORD}`,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
};

